import axios from "axios";
import API_BASE_URL from "../components/config";
// const API_URL = 'https://web1024.docmaster.in:5007/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = async (credentials) => {
  const response = await api.post("/auth/login", credentials);
  console.log(response);
  return response.data;
};

export const signUp = async (credentails) => {
  const response = await api.post("/auth/signup", credentails);
  return response.data;
};

export default api;
